import { Auth0ClientOptions } from '@auth0/auth0-spa-js';

import { auth0Client, auth0Config } from './auth0-client';
import { Authenticator } from '../../authenticator';
import { Auth0Authenticator } from '../../authenticator/auth0/auth0-authenticator';

/** Authenticator Singleton instance */
let _instance: Authenticator<Auth0ClientOptions> | undefined;

if (!_instance) {
  _instance = new Auth0Authenticator(auth0Config, auth0Client);
}

const auth0Authenticator = _instance;

export { auth0Config, auth0Authenticator };
